
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 12.09c-.53.09-1.03.25-1.5.46V5H11v7.09zM5.5 20.5c-2.21 0-4-1.79-4-4V4a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V5H3v9.5A2.5 2.5 0 005.5 17c.21 0 .41-.03.6-.08.25-1.34.93-2.51 1.9-3.38V4c0-2.21-1.79-4-4-4S0 1.79 0 4v12.5a5.497 5.497 0 007.29 5.2c-.32-.41-.59-.86-.79-1.34-.33.08-.66.14-1 .14zM13 17v-3h-2v3H8v2h3v3h2v-3h3v-2h-3z","fill":"#00671D"}})])
          )
        }
      }
    